{
  "hero": {
    "title": "Start your 7-day Free Trial",
    "subtitle": "Verifiable Parental Consent Required",
    "notice": "To comply with child safety laws (COPPA), we require a valid payment method to verify you are an adult.",
    "noticeStrong": " You won't be charged until the trial ends."
  },
  "plans": {
    "monthly": {
      "title": "Monthly",
      "period": "/mo",
      "note": "Billed monthly. Cancel anytime."
    },
    "annual": {
      "badge": "Save 17%",
      "title": "Yearly",
      "period": "/yr",
      "note": "Billed annually."
    }
  },
  "payment": {
    "title": "Payment",
    "stripe": "Redirected to Stripe's secure checkout",
    "trial": "7-day free trial",
    "cancel": "Cancel anytime"
  },
  "consent": {
    "label": "I am the parent/guardian and consent to the collection of my child's data.",
    "note": "We collect minimal data (nickname, grade) to provide the service."
  },
  "actions": {
    "redirecting": "Redirecting to Stripe...",
    "checkout": "Continue to Secure Checkout",
    "decideLater": "I'll decide later"
  },
  "errors": {
    "missingCheckout": "Missing Stripe checkout URL",
    "default": "Something went wrong. Please try again."
  }
}
